// Module
var code = "<div id=\"V-7410C805-0F1E-45C6-B0FF-527F0C23F462\"> <div data-b-component=\"input\" class=\"input\" data-b-comp-text=\"{Binding value}\" data-b-comp-allowsuggestion=\"true\" data-b-comp-suggestionsseparator=\"&nbsp\" data-b-comp-suggestions=\"{Binding suggestions}\"></div> </div> ";
// Exports
export default code;